import { instance } from './instance';

export interface FeedProgram {
  recruitmentActive: boolean;
  feedEnabled: boolean;
  minReviews: number;
  invitationLimit: number;
  endedAt: string | null;
}

export interface FeedBetaDashboard {
  program: FeedProgram;
  members: number;
  rewarded: number;
  rewardsPending: number;
  sharedReviews: number;
  approvedReviews: number;
  pendingReviews: number;
  topReviewers: {
    userId: number;
    username: string;
    reviewCount: number;
    joined: boolean;
  }[];
}

export interface FeedReviewImportResult {
  processed: number;
  published: number;
  pending: number;
  skipped: number;
  failed: number;
  hasMore: boolean;
}

export const staffBeta = {
  importReviews: async (): Promise<FeedReviewImportResult> =>
    (await instance.post('/admin/feed/beta/import-reviews')).data.data,
  dashboard: async (): Promise<FeedBetaDashboard> =>
    (await instance.get('/admin/feed/beta')).data.data,
  update: (data: Partial<Omit<FeedProgram, 'endedAt'>>) =>
    instance.patch('/admin/feed/beta', data),
  end: () => instance.post('/admin/feed/beta/end'),
  rewards: async (): Promise<{ issued: number; remaining: number }> =>
    (await instance.post('/admin/feed/beta/rewards')).data.data,
};
